import React from "react";
import { getInstantValidationState } from '../../../utils/realTimeValidationUtils';

import './VR12.scss';

const VR12 = ({ handleFormData, values, fieldErrors = {}, touchedFields = {} }) => {
  return (
    <div className="modern-assessment">
      <h2 className="assessment-title">VR12</h2>      
      <h3 className="assessment-subtitle">
        Deze vragenlijst vraagt naar uw mening over uw gezondheid.
        De informatie helpt u bijhouden hoe u zich voelt en hoe goed u in staat bent om uw normale activiteiten uit te voeren.
        Beantwoord elke vraag door het antwoord te markeren zoals aangegeven.
        Indien u niet zeker bent over het antwoord op een vraag, kies dan het antwoord dat volgens u het beste is
      </h3>      
      {(() => {
        const validation = getInstantValidationState('vr12.vr12Question1', fieldErrors, touchedFields, values.vr12.vr12Question1);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">1. Hoe beoordeelt u uw gezondheid over het algemeen?</label>
            <select
              name="vr12Question1"
              aria-label="Hoe beoordeelt u uw gezondheid over het algemeen?"
              className={validation.inputClasses('modern-form-select')}
              required
              value={values.vr12.vr12Question1}
              onChange={(event) => handleFormData("vr12", "vr12Question1", event.target.value)}
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Uitstekend">Uitstekend</option>
              <option value="Zeer goed">Zeer goed</option>
              <option value="Goed">Goed</option>
              <option value="Redelijk">Redelijk</option>
              <option value="Slecht">Slecht</option>
            </select>
            
          </div>
        );
      })()}

      <h3 className="assessment-subtitle">
        De volgende 2 vragen gaan over activiteiten die u op een normale dag uitvoert.
        Beperkt uw gezondheid u nu in deze activiteiten? Zo ja, in welke mate?
      </h3>      

      {(() => {
        const validation = getInstantValidationState('vr12.vr12Question2', fieldErrors, touchedFields, values.vr12.vr12Question2);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">2. Gematigde activiteiten, zoals een tafel verplaatsen, een stofzuiger voortduwen, bowlen of golfen?</label>
            <select
              name="vr12Question2"
              aria-label="Gematigde activiteiten, zoals een tafel verplaatsen, een stofzuiger voortduwen, bowlen of golfen?"
              className={validation.inputClasses('modern-form-select')}
              required
              value={values.vr12.vr12Question2}
              onChange={(event) => handleFormData("vr12", "vr12Question2", event.target.value)}
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Ja heel erg">Ja heel erg</option>
              <option value="Ja een beetje">Ja een beetje</option>
              <option value="Nee, helemaal niet">Nee, helemaal niet</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('vr12.vr12Question3', fieldErrors, touchedFields, values.vr12.vr12Question3);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">3. Traplopen?</label>
            <select
              name="vr12Question3"
              aria-label="Traplopen?"
              className={validation.inputClasses('modern-form-select')}
              required
              value={values.vr12.vr12Question3}
              onChange={(event) => handleFormData("vr12", "vr12Question3", event.target.value)}
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Ja heel erg">Ja heel erg</option>
              <option value="Ja een beetje">Ja een beetje</option>
              <option value="Nee, helemaal niet">Nee, helemaal niet</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('vr12.vr12Question4', fieldErrors, touchedFields, values.vr12.vr12Question4);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">4. Hebt u de afgelopen 4 weken een van de volgende problemen ondervonden in uw werk of bij andere regelmatige dagelijkse activiteiten als gevolg van uw lichamelijke gezondheid? U hebt minder bereikt dan u zou willen?</label>
            <select
              name="vr12Question4"
              aria-label="Hebt u de afgelopen 4 weken een van de volgende problemen ondervonden in uw werk of bij andere regelmatige dagelijkse activiteiten als gevolg van uw lichamelijke gezondheid? U hebt minder bereikt dan u zou willen?"
              className={validation.inputClasses('modern-form-select')}
              required
              value={values.vr12.vr12Question4}
              onChange={(event) => handleFormData("vr12", "vr12Question4", event.target.value)}
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Nee, nooit">Nee, nooit</option>
              <option value="Ja, zelden">Ja, zelden</option>
              <option value="Ja, soms">Ja, soms</option>
              <option value="Ja, bijna altijd">Ja, bijna altijd</option>
              <option value="Ja, voortdurend">Ja, voortdurend</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('vr12.vr12Question5', fieldErrors, touchedFields, values.vr12.vr12Question5);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">5. U werd beperkt in het soort werk of andere activiteiten.</label>
            <select
              name="vr12Question5"
              aria-label="U werd beperkt in het soort werk of andere activiteiten."
              className={validation.inputClasses('modern-form-select')}
              required
              value={values.vr12.vr12Question5}
              onChange={(event) => handleFormData("vr12", "vr12Question5", event.target.value)}
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Nee, nooit">Nee, nooit</option>
              <option value="Ja, zelden">Ja, zelden</option>
              <option value="Ja, soms">Ja, soms</option>
              <option value="Ja, bijna altijd">Ja, bijna altijd</option>
              <option value="Ja, voortdurend">Ja, voortdurend</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('vr12.vr12Question6', fieldErrors, touchedFields, values.vr12.vr12Question6);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">6. U hebt minder bereikt dan u zou willen.</label>
            <select
              name="vr12Question6"
              aria-label="U hebt minder bereikt dan u zou willen."
              className={validation.inputClasses('modern-form-select')}
              required
              value={values.vr12.vr12Question6}
              onChange={(event) => handleFormData("vr12", "vr12Question6", event.target.value)}
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Nee, nooit">Nee, nooit</option>
              <option value="Ja, zelden">Ja, zelden</option>
              <option value="Ja, soms">Ja, soms</option>
              <option value="Ja, bijna altijd">Ja, bijna altijd</option>
              <option value="Ja, voortdurend">Ja, voortdurend</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('vr12.vr12Question7', fieldErrors, touchedFields, values.vr12.vr12Question7);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">7. U voerde uw werk of andere activiteiten niet zo zorgvuldig uit als normaal.</label>
            <select
              name="vr12Question7"
              aria-label="U voerde uw werk of andere activiteiten niet zo zorgvuldig uit als normaal."
              className={validation.inputClasses('modern-form-select')}
              required
              value={values.vr12.vr12Question7}
              onChange={(event) => handleFormData("vr12", "vr12Question7", event.target.value)}
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Nee, nooit">Nee, nooit</option>
              <option value="Ja, zelden">Ja, zelden</option>
              <option value="Ja, soms">Ja, soms</option>
              <option value="Ja, bijna altijd">Ja, bijna altijd</option>
              <option value="Ja, voortdurend">Ja, voortdurend</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('vr12.vr12Question8', fieldErrors, touchedFields, values.vr12.vr12Question8);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">8. In welke mate hebt u de afgelopen 4 weken pijn ondervonden tijdens uw normale werk (zowel werk buitenshuis als huishoudelijk werk)?</label>
            <select
              name="vr12Question8"
              aria-label="In welke mate hebt u de afgelopen 4 weken pijn ondervonden tijdens uw normale werk (zowel werk buitenshuis als huishoudelijk werk)?"
              className={validation.inputClasses('modern-form-select')}
              required
              value={values.vr12.vr12Question8}
              onChange={(event) => handleFormData("vr12", "vr12Question8", event.target.value)}
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Helemaal niet">Helemaal niet</option>
              <option value="Een klein beetje">Een klein beetje</option>
              <option value="Matig">Matig</option>
              <option value="Heel veel">Heel veel</option>
              <option value="Extreem veel">Extreem veel</option>
            </select>
            
          </div>
        );
      })()}

      <h3 className="assessment-subtitle">De volgende 4 vragen gaan over hoe u zich voelt en hoe het u de afgelopen 4 weken is vergaan. Voorzie elke vraag van het antwoord dat uw gevoel van de afgelopen periode het beste beschrijft.</h3>      

      {(() => {
        const validation = getInstantValidationState('vr12.vr12Question9', fieldErrors, touchedFields, values.vr12.vr12Question9);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">9. Voelde u zich kalm en tevreden?</label>
            <select
              name="vr12Question9"
              aria-label="Voelde u zich kalm en tevreden?"
              className={validation.inputClasses('modern-form-select')}
              required
              value={values.vr12.vr12Question9}
              onChange={(event) => handleFormData("vr12", "vr12Question9", event.target.value)}
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Voortdurend">Voortdurend</option>
              <option value="Bijna altijd">Bijna altijd</option>
              <option value="Vaak">Vaak</option>
              <option value="Soms">Soms</option>
              <option value="Zelden">Zelden</option>
              <option value="Nooit">Nooit</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('vr12.vr12Question10', fieldErrors, touchedFields, values.vr12.vr12Question10);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">10. Voelde u zich zeer energiek?</label>
            <select
              name="vr12Question10"
              aria-label="Voelde u zich zeer energiek?"
              className={validation.inputClasses('modern-form-select')}
              required
              value={values.vr12.vr12Question10}
              onChange={(event) => handleFormData("vr12", "vr12Question10", event.target.value)}
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Voortdurend">Voortdurend</option>
              <option value="Bijna altijd">Bijna altijd</option>
              <option value="Vaak">Vaak</option>
              <option value="Soms">Soms</option>
              <option value="Zelden">Zelden</option>
              <option value="Nooit">Nooit</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('vr12.vr12Question11', fieldErrors, touchedFields, values.vr12.vr12Question11);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">11. Voelde u zich neerslachtig en gedeprimeerd?</label>
            <select
              name="vr12Question11"
              aria-label="Voelde u zich neerslachtig en gedeprimeerd?"
              className={validation.inputClasses('modern-form-select')}
              required
              value={values.vr12.vr12Question11}
              onChange={(event) => handleFormData("vr12", "vr12Question11", event.target.value)}
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Voortdurend">Voortdurend</option>
              <option value="Bijna altijd">Bijna altijd</option>
              <option value="Vaak">Vaak</option>
              <option value="Soms">Soms</option>
              <option value="Zelden">Zelden</option>
              <option value="Nooit">Nooit</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('vr12.vr12Question12', fieldErrors, touchedFields, values.vr12.vr12Question12);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">12. Hoe vaak heeft uw lichamelijke gezondheid of emotionele problemen de afgelopen 4 weken invloed gehad op uw sociale activiteiten (zoals het bezoeken van vrienden, bekenden, enz.)?</label>
            <select
              name="vr12Question12"
              aria-label="Hoe vaak heeft uw lichamelijke gezondheid of emotionele problemen de afgelopen 4 weken invloed gehad op uw sociale activiteiten (zoals het bezoeken van vrienden, bekenden, enz.)?"
              className={validation.inputClasses('modern-form-select')}
              required
              value={values.vr12.vr12Question12}
              onChange={(event) => handleFormData("vr12", "vr12Question12", event.target.value)}
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Voortdurend">Voortdurend</option>
              <option value="Bijna altijd">Bijna altijd</option>
              <option value="Vaak">Vaak</option>
              <option value="Soms">Soms</option>
              <option value="Zelden">Zelden</option>
              <option value="Nooit">Nooit</option>
            </select>
            
          </div>
        );
      })()}

      <h3 className="assessment-subtitle">Nu willen we u een paar vragen stellen over hoe uw gezondheid mogelijk is veranderd.</h3>      
    
      {(() => {
        const validation = getInstantValidationState('vr12.vr12Question13', fieldErrors, touchedFields, values.vr12.vr12Question13);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">13. Hoe zou u nu, vergeleken met een jaar geleden, uw lichamelijke gezondheid over het algemeen beoordelen?</label>
            <select
              name="vr12Question13"
              aria-label="Hoe zou u nu, vergeleken met een jaar geleden, uw lichamelijke gezondheid over het algemeen beoordelen?"
              className={validation.inputClasses('modern-form-select')}
              required
              value={values.vr12.vr12Question13}
              onChange={(event) => handleFormData("vr12", "vr12Question13", event.target.value)}
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Veel beter">Veel beter</option>
              <option value="Iets beter">Iets beter</option>
              <option value="Ongeveer hetzelfde">Ongeveer hetzelfde</option>
              <option value="Iets slechter">Iets slechter</option>
              <option value="Veel slechter">Veel slechter</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('vr12.vr12Question14', fieldErrors, touchedFields, values.vr12.vr12Question14);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">14. Hoe zou u nu, vergeleken met een jaar geleden, uw emotionele problemen (bijvoorbeeld angstige, depressieve of prikkelbare gevoelens) beoordelen?</label>
            <select
              name="vr12Question14"
              aria-label="Hoe zou u nu, vergeleken met een jaar geleden, uw emotionele problemen (bijvoorbeeld angstige, depressieve of prikkelbare gevoelens) beoordelen?"
              className={validation.inputClasses('modern-form-select')}
              required
              value={values.vr12.vr12Question14}
              onChange={(event) => handleFormData("vr12", "vr12Question14", event.target.value)}
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Veel beter">Veel beter</option>
              <option value="Iets beter">Iets beter</option>
              <option value="Ongeveer hetzelfde">Ongeveer hetzelfde</option>
              <option value="Iets slechter">Iets slechter</option>
              <option value="Veel slechter">Veel slechter</option>
            </select>
            
          </div>
        );
      })()}
    </div>
  );
}

export default VR12;